import { getGstaUrl } from "../Helper/ReadWriteApiPath";

// Convertit un Blob PDF en base64 (pour l’envoyer au backend)
async function blobToBase64(blob) {
  const buf = await blob.arrayBuffer();
  const bytes = new Uint8Array(buf);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

export async function sendEmailWithPdf(to, subject, filename, pdfBlob, html) {
  console.log("Send mail ", filename);
  const content = await blobToBase64(pdfBlob);
  const payload = {
    to,
    subject,
    html,
    attachments: [
      {
        filename,
        content,
        contentType: "application/pdf"
      }
    ]
  };
  let res;
  try {
    res = await fetch(`${getGstaUrl()}/api/send-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
  } catch (e) {
    console.error("❌ Error send mail", {
      name: e?.name,
      message: e?.message,
      stack: e?.stack,
    });
  }

  if (!res.ok) {
    console.error("❌ Error send mail: ", res.status)
    throw new Error(`HTTP ${res.status}`);
  } else {
    console.log("Email sent ✅ :", res);
  }
  return res.json();
}

export async function sendEmailWithManyPdfs(to, subject, files, html) {
  const attachments = [];
  for (const f of files) {
    const content = await blobToBase64(f.blob);
    attachments.push({
      filename: f.filename,
      content,                       // base64
      contentType: "application/pdf"
    });
  }
  let res;
  try {
    res = await fetch(`${getGstaUrl()}/api/send-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to, subject, html, attachments })
    });
    if (!res.ok) {
      console.error("❌ Error send mail: ", res.status)
      throw new Error(`HTTP ${res.status}`);
    } else {
      console.log("Email sent ✅ :");
    }
  } catch (e) {
    console.error("❌ Error send mail", {
      name: e?.name,
      message: e?.message,
      stack: e?.stack,
    });
  }

  return res.json();
}
